angular.module('moebiusProadapt').controller('ctrlQvShowHistory',
    ['$scope', '$http', '$location', '$uibModal', 'promiseTracker', 'mbsEtiService', 'mbsUser', 'moment', function ($scope, $http, $location, $uibModal, promiseTracker, mbsEtiService, mbsUser, moment) {


        console.log('history',$scope.history);
        console.log($scope.questionVisite.id);

    // --
        //get values here
        _.each($scope.history, function(entry) {
            // questionVisite.localAttributes.dynamicDropDown|_:'find':{id: participant.participantValuesByQuestionVisiteId[questionVisite.id][questionVisite.overwritePriority] }).name
            var entryValue = entry[$scope.questionVisite.overwritePriority];
            var listValue, value;
            if ([
                    $scope.constants.input_types.NAMES_TO_VALUES.SLIDER_BY_IDX,
                    $scope.constants.input_types.NAMES_TO_VALUES.DROPDOWN_BY_IDX,
                    $scope.constants.input_types.NAMES_TO_VALUES.RADIO_BY_IDX,
                ].indexOf($scope.questionMere.inputType) > -1) {
                listValue = _.find($scope.questionVisite.localAttributes.dynamicDropDown, function (v) {
                    return v.id == entryValue
                });
                value = _.isUndefined(listValue) ? entryValue : listValue.name;
            }
            else if ([
                    $scope.constants.input_types.NAMES_TO_VALUES.MULTIPLE_CHECKBOX
                ].indexOf($scope.questionMere.inputType) > -1) {

                var entryValues = JSON.parse(entryValue);
                value = '';
                if (_.isArray(entryValues) && entryValues.length > 0) {
                    _.each(entryValues, function(singleValue) {
                        listValue = _.find($scope.questionVisite.localAttributes.dynamicDropDown, function (v) {
                            return v.id == singleValue
                        });
                        value += _.isUndefined(listValue) ? singleValue : listValue.name + '<br/>';
                    })
                } else {
                    // -- empty choice
                }


            }
            else if ($scope.questionMere.inputType === $scope.constants.input_types.NAMES_TO_VALUES.BOOLEAN) {
                if (entryValue == "0") {
                    value = 'NON';
                } else if (entryValue == "1") {
                    value = 'OUI';
                } else {
                    value = '';
                }
            }
            else if ($scope.questionMere.inputType === $scope.constants.input_types.NAMES_TO_VALUES.TEXT){
                value = entryValue;
            }
            else if ($scope.questionMere.inputType === $scope.constants.input_types.NAMES_TO_VALUES.DATE){
                if (entryValue) {
                    value = moment(entryValue).format('DD/MM/YYYY');
                }
            }
            if(entry['nd']){
                value='ND';
            }

            console.log(entryValue,listValue, $scope.questionVisite.localAttributes.dynamicDropDown,value);
            entry.value = value;
            var str = entry.updated_at.replace(' ','T')+'.000Z';
            var m1 = moment(str).utcOffset(str);
            entry.date = m1.toDate();


            entry.updated_by_username = $scope.constants.users[entry.updated_by]['name'];
            if (entry.updated_by_username === 'raphael@anamnese.me') {
                entry.updated_by_username = 'Patient depuis la tablette';
            }
        });


    }]
);


// WEBPACK FOOTER //
// ./resources/assets/js/controllers/etude/qvShowHistory.js